import { EmberRoute } from '../../enums/emberRoute'

export const isEmberRoute = (route: string): route is EmberRoute => {
  return Object.values(EmberRoute).includes(route as EmberRoute)
}
